import React, {  useEffect } from "react";
import { Box } from "devextreme-react";
import { Item } from "devextreme-react/box";
import http from "../../utils/http";
import uri from "../../utils/uri";
import { store } from "../../services/store";
import {DataGrid, Column, MasterDetail } from "devextreme-react/data-grid";
import { useDispatch } from 'react-redux';
import  DetailTemplate from "./DetailTemplate.js";
import { loadItmeProviders } from "../../store/itemProvider/itemProviderReducer";
import Title from "../../components/shared/Title";
import BlockHeader from "../../components/shared/BlockHeader";
import useAuthorization from "../../hooks/useAuthorization";
import { dataAccess, resources } from "../../data/app";

const ItemProviders = props => {

    const { authorized } = useAuthorization([resources.catalogos, dataAccess.access ]);

    let dispatch = useDispatch();

    const onLoad = (e) => {
        http(uri.providerCatalog).asGet().then(resp => {
            dispatch(loadItmeProviders(resp));
        });
      }

    useEffect(() => {
        onLoad();
    }, [0]);

    const title = 'Proveedores por articulo'

    return authorized(
        <div className="container medium">
            <Title title={title} />
            <BlockHeader title={title} />
            <Box direction="row" width="100%" height={75}>
                <Item ratio={1}>
                    <DataGrid
                        dataSource={store({ uri: uri.itemProviders })}
                        keyExpr="id"
                        showBorders={true}
                        showRowLines={true}
                    >
                        <Column dataField="id" caption="Id" width={60} visible={false} allowEditing={false} />
                        <Column dataField="name" caption="Nombre"/>
                        <Column dataField="description" visible={false} width={200} />
                        <Column dataField="sku" caption="SKU" width={120} />
                        <Column dataField="unitMeasure" caption="Unidad de Medida" width={200} />
                        {/* <Column dataField="price" caption="Precio de Venta" width={120} />
                        <Column dataField="cost" caption="Costo" width={120} /> */}
                        <Column dataField="quantity" caption="Cantidad" width={120} />
                        {/* <Column dataField="reorderPoint" caption="Punto de reorden" width={120} /> */}
                        <MasterDetail
                            enabled={true}
                            component={DetailTemplate}
                        />
                    </DataGrid>
                </Item>
            </Box>
        </div>
    );
}

export default ItemProviders;